import React from "react";
import { useHistory } from "react-router-dom";
import loginService from "./service/login.service";
import LoginNative from "./Login.native";
import storageService from "../../../services/storage.service";
import authService from "../../../services/auth.service";
import AuthUser from "../../../models/auth-user.entity";

const LoginContainer = () => {
  const history = useHistory();
  const [email, setEmail] = React.useState<string>('');
  const [password, setPassword] = React.useState<string>('');
  const [loading, setLoading] = React.useState<boolean>(false);
  const [errors, setErrors] = React.useState<any>({});
  const [showErrorToast, setShowErrorToast] = React.useState<boolean>(false);

  const REQUIRED_FIELD_MSG = 'Este campo é obrigatório';

  const validateForm = (): boolean => {
    const validationErrors: any = {};
    if (!email) validationErrors.email = REQUIRED_FIELD_MSG;
    if (!password) validationErrors.password = REQUIRED_FIELD_MSG;

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  }

  const onChangeEmail = (value: string) => {
    setEmail(value);
    setErrors((prev: any) => (prev.email ? { ...prev, email: '' } : prev));
  }

  const onChangePassword = (value: string) => {
    setPassword(value);
    setErrors((prev: any) => (prev.password ? { ...prev, password: '' } : prev));
  }

  const savingUpdateDate = () => {
    const dateNow = new Date();
    storageService.setObject('update-session', dateNow);
  }

  const saveUserInfo = async (token: string) => {
    return authService.getAuthUserInfo(token)
      .then((result) => {
      const { company } = result;

      storageService.setObject('company', company);

      savingUserColor(company);
      history.push('/first-step');
    });
  }

  const logIn = () => {
    if (!validateForm()) return;

    setLoading(true);

    loginService.logIn(email, password)
      .then((result: any) => {
        const { data } = result.data;

        storageService.setObject('session', data);
        authService.saveAuth(new AuthUser(data));

        savingUpdateDate();
        saveUserInfo(data.access_token);
      })
      .catch(() => {
        setShowErrorToast(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const savingUserColor = (company: any) => {
    document.documentElement.style.setProperty('--infovist-primary', company.color);
  }

  return (
    <LoginNative
      setPassword={onChangePassword}
      setEmail={onChangeEmail}
      loading={loading}
      errors={errors}
      logIn={logIn}
      showErrorToast={showErrorToast}
      closeErrorToast={() => setShowErrorToast(false)}
    />
  );
};

export default LoginContainer;
